// Home page mock data - extracted for maintainability
import { BookCatalogEntry } from './booksData'

// Keep the Book type alias for backward compat
export type Book = BookCatalogEntry

export interface Book {
  id: string
  title: string
  author: string
  coverImage: string
  rating: number
  formats?: string[]
  genres?: string[]
  isNew?: boolean
  isDebut?: boolean
  spiceLevel?: number
  darknessLevel?: number
  reviewCount?: number
  seriesName?: string
  seriesNumber?: number
  totalSeriesBooks?: number
  seriesStatus?: string
  endingType?: string
  characterRelationships?: Array<{
    type: string
    style?: string[]
    characters?: string
  }>
}
export interface MerchProduct {
  id: string
  title: string
  vendor: string
  image: string
  price: number
  relatedBook?: string
  isOfficialMerch?: boolean
  genre?: string
}
export interface TroveArticle {
  id: string
  title: string
  author: string
  image: string
  date: string
  category: string
  excerpt: string
}
export interface Trope {
  name: string
  color: string
  count: number
}
export interface ReaderReview {
  id: string
  bookId: string
  bookTitle: string
  bookCover: string
  author: string
  reviewerName: string
  rating: number
  quote: string
  date: string
}
export interface UpcomingEvent {
  id: string
  title: string
  date: string
  time: string
  type: string
  description: string
  image: string
  location?: string
}
export interface SpotlightAuthor {
  id: string
  name: string
  bio: string
  image: string
  books: {
    debut: {
      id: string
      title: string
      coverImage: string
      genres: string[]
      releaseDate: string
    }
    mostPopular: {
      id: string
      title: string
      coverImage: string
      genres: string[]
      rating: number
      reviewCount: number
    }
    latest: {
      id: string
      title: string
      coverImage: string
      genres: string[]
      releaseDate: string
      isNew?: boolean
    }
    leastReviewed: {
      id: string
      title: string
      coverImage: string
      genres: string[]
      reviewCount: number
    }
  }
  socialLinks: {
    website: string
    instagram: string
    tiktok: string
  }
}
export interface ThemeOfWeek {
  theme: string
  description: string
  color: string
  books: Book[]
}

// Featured Books
export const featuredBooks: Book[] = [
  {
    id: '1',
    title: 'The Silent Echo',
    author: 'Elena Richards',
    coverImage:
      'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.7,
    formats: ['paperback', 'ebook', 'audiobook'],
    genres: ['Mystery', 'Thriller'],
    isNew: true,
    seriesName: 'Echo Series',
    seriesNumber: 1,
    totalSeriesBooks: 3,
    seriesStatus: 'ongoing',
    darknessLevel: 4,
    endingType: 'HEA',
    characterRelationships: [
      {
        type: 'Enemies to Lovers',
        style: ['Male & Female (MF)', 'Slow Burn'],
        characters: 'Mira Hayes & Detective Ryan Cole',
      },
    ],
    spiceLevel: 3,
  },
  {
    id: '2',
    title: 'Beyond the Veil',
    author: 'Marcus Chen',
    coverImage:
      'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.5,
    formats: ['ebook', 'audiobook'],
    genres: ['Fantasy', 'Young Adult'],
    spiceLevel: 1,
    darknessLevel: 2,
  },
  {
    id: '3',
    title: 'Whispers in the Dark',
    author: 'Sarah Johnson',
    coverImage:
      'https://images.unsplash.com/photo-1621351183012-e2f9972dd9bf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.8,
    formats: ['paperback', 'ebook'],
    genres: ['Horror', 'Supernatural'],
    spiceLevel: 2,
    darknessLevel: 5,
  },
  {
    id: '4',
    title: 'The Lost City',
    author: 'David Williams',
    coverImage:
      'https://images.unsplash.com/photo-1541963463532-d68292c34b19?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.3,
    formats: ['hardcover', 'ebook', 'audiobook'],
    genres: ['Adventure', 'Historical Fiction'],
    spiceLevel: 2,
    darknessLevel: 3,
  },
  {
    id: '5',
    title: 'Starfall',
    author: 'Amara Knight',
    coverImage:
      'https://images.unsplash.com/photo-1518744386442-2d48ac55263f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.9,
    formats: ['paperback', 'ebook'],
    genres: ['Sci-Fi', 'Romance'],
    isNew: true,
    spiceLevel: 4,
    darknessLevel: 2,
    characterRelationships: [
      {
        type: 'Slow Burn',
        style: ['Male & Female (MF)'],
      },
    ],
  },
  {
    id: '6',
    title: 'The Hidden Truth',
    author: 'Thomas Lee',
    coverImage:
      'https://images.unsplash.com/photo-1633477189729-9290b3261d0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.2,
    formats: ['ebook'],
    genres: ['Mystery', 'Crime'],
    spiceLevel: 2,
    darknessLevel: 3,
  },
]

// New Releases
export const newReleases: Book[] = [
  {
    id: '7',
    title: 'Echoes of Tomorrow',
    author: 'Zoe Parker',
    coverImage:
      'https://images.unsplash.com/photo-1531928351158-2f736078e0a1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.6,
    formats: ['hardcover', 'ebook'],
    genres: ['Sci-Fi', 'Dystopian'],
    isNew: true,
    spiceLevel: 2,
    darknessLevel: 3,
  },
  {
    id: '8',
    title: 'The Last Spell',
    author: 'Finn Murphy',
    coverImage:
      'https://images.unsplash.com/photo-1589998059171-988d887df646?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.8,
    formats: ['paperback', 'ebook', 'audiobook'],
    genres: ['Fantasy', 'Magic'],
    isNew: true,
    spiceLevel: 3,
    darknessLevel: 2,
  },
  {
    id: '9',
    title: 'Beneath the Surface',
    author: 'Maya Rodriguez',
    coverImage:
      'https://images.unsplash.com/photo-1610882648335-ced8fc8fa6b6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.7,
    formats: ['paperback', 'ebook'],
    genres: ['Thriller', 'Psychological'],
    isNew: true,
    spiceLevel: 3,
    darknessLevel: 4,
  },
  {
    id: '10',
    title: 'The Forgotten Path',
    author: 'Liam Bennett',
    coverImage:
      'https://images.unsplash.com/photo-1612969308146-066027504792?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.5,
    formats: ['hardcover', 'ebook', 'audiobook'],
    genres: ['Adventure', 'Coming of Age'],
    isNew: true,
    spiceLevel: 1,
    darknessLevel: 2,
  },
]

// Debut Authors Books
export const debutAuthorsBooks: Book[] = [
  {
    id: 'debut1',
    title: 'Whispers of the Forgotten',
    author: 'Maya Collins',
    coverImage:
      'https://images.unsplash.com/photo-1603162525937-92a06da4b8ba?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 0,
    formats: ['paperback', 'ebook'],
    genres: ['Fantasy', 'Debut'],
    isNew: true,
    spiceLevel: 2,
    isDebut: true,
  },
  {
    id: 'debut2',
    title: 'The Last Lighthouse Keeper',
    author: 'Thomas Reed',
    coverImage:
      'https://images.unsplash.com/photo-1580934738404-5eb8d4c0389e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 0,
    formats: ['ebook'],
    genres: ['Historical Fiction', 'Debut'],
    isNew: true,
    spiceLevel: 1,
    isDebut: true,
  },
  {
    id: 'debut3',
    title: 'Parallel Hearts',
    author: 'Sophia Chen',
    coverImage:
      'https://images.unsplash.com/photo-1544084944-15c3893308fb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 3.5,
    formats: ['paperback', 'ebook'],
    genres: ['Romance', 'Debut'],
    isNew: true,
    spiceLevel: 3,
    isDebut: true,
  },
  {
    id: 'debut4',
    title: 'Midnight Protocol',
    author: 'James Wilson',
    coverImage:
      'https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.1,
    formats: ['ebook', 'audiobook'],
    genres: ['Thriller', 'Sci-Fi', 'Debut'],
    isNew: true,
    spiceLevel: 2,
    isDebut: true,
  },
  {
    id: 'debut5',
    title: "The Botanist's Daughter",
    author: 'Emma Lawson',
    coverImage:
      'https://images.unsplash.com/photo-1580933073521-dc49ac0d4e6a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 0,
    formats: ['paperback', 'ebook'],
    genres: ['Mystery', 'Literary Fiction', 'Debut'],
    isNew: true,
    spiceLevel: 1,
    isDebut: true,
  },
  {
    id: 'debut6',
    title: 'Echoes of Silence',
    author: 'Daniel Martinez',
    coverImage:
      'https://images.unsplash.com/photo-1541963463532-d68292c34b19?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 3.8,
    formats: ['ebook', 'audiobook'],
    genres: ['Literary Fiction', 'Debut'],
    isNew: true,
    spiceLevel: 2,
    isDebut: true,
  },
  {
    id: 'debut7',
    title: 'Quantum Memories',
    author: 'Aisha Johnson',
    coverImage:
      'https://images.unsplash.com/photo-1518744386442-2d48ac55263f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.2,
    formats: ['paperback', 'ebook'],
    genres: ['Sci-Fi', 'Debut'],
    isNew: true,
    spiceLevel: 3,
    isDebut: true,
  },
]

// Hidden Gems
export const hiddenGems: Book[] = [
  {
    id: 'hidden1',
    title: 'The Forgotten Prophecy',
    author: 'Lucas Bennett',
    coverImage:
      'https://images.unsplash.com/photo-1612969308146-066027504792?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.5,
    formats: ['paperback', 'ebook'],
    genres: ['Fantasy', 'Adventure'],
    reviewCount: 12,
    spiceLevel: 2,
    darknessLevel: 2,
  },
  {
    id: 'hidden2',
    title: 'Echoes in the Mist',
    author: 'Olivia Chen',
    coverImage:
      'https://images.unsplash.com/photo-1589998059171-988d887df646?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.8,
    formats: ['ebook'],
    genres: ['Mystery', 'Supernatural'],
    reviewCount: 8,
    spiceLevel: 3,
    darknessLevel: 3,
  },
  {
    id: 'hidden3',
    title: 'Beneath the Surface',
    author: 'Ethan Parker',
    coverImage:
      'https://images.unsplash.com/photo-1610882648335-ced8fc8fa6b6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.7,
    formats: ['paperback', 'ebook', 'audiobook'],
    genres: ['Thriller', 'Mystery'],
    reviewCount: 15,
    spiceLevel: 4,
    darknessLevel: 4,
  },
  {
    id: 'hidden4',
    title: 'Whispers of the Heart',
    author: 'Sophia Miller',
    coverImage:
      'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.6,
    formats: ['ebook', 'audiobook'],
    genres: ['Romance', 'Contemporary'],
    reviewCount: 11,
    spiceLevel: 3,
    darknessLevel: 1,
    endingType: 'HEA',
    characterRelationships: [{ type: 'Friends to Lovers' }],
  },
  {
    id: 'hidden5',
    title: 'The Last Guardian',
    author: 'Michael Anderson',
    coverImage:
      'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.9,
    formats: ['paperback', 'ebook'],
    genres: ['Fantasy', 'Young Adult'],
    reviewCount: 7,
    spiceLevel: 2,
    darknessLevel: 2,
  },
  {
    id: 'hidden6',
    title: 'Starlight Chronicles',
    author: 'Emma Watson',
    coverImage:
      'https://images.unsplash.com/photo-1518744386442-2d48ac55263f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.7,
    formats: ['ebook'],
    genres: ['Sci-Fi', 'Adventure'],
    reviewCount: 9,
    spiceLevel: 2,
    darknessLevel: 2,
  },
  {
    id: 'hidden7',
    title: 'The Silent Truth',
    author: 'David Williams',
    coverImage:
      'https://images.unsplash.com/photo-1633477189729-9290b3261d0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    rating: 4.8,
    formats: ['paperback', 'ebook', 'audiobook'],
    genres: ['Thriller', 'Crime'],
    reviewCount: 14,
    spiceLevel: 4,
    darknessLevel: 4,
  },
]

// Featured Merchandise
export const featuredMerch: MerchProduct[] = [
  {
    id: '1',
    title: 'Silent Echo T-Shirt',
    vendor: 'Literary Apparel Co.',
    image:
      'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=600&q=80',
    price: 24.99,
    relatedBook: 'The Silent Echo',
    isOfficialMerch: true,
    genre: 'Mystery',
  },
  {
    id: '2',
    title: 'Starfall Constellation Mug',
    vendor: 'Cosmic Creations',
    image:
      'https://images.unsplash.com/photo-1577937927133-66ef06acdf18?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=600&q=80',
    price: 18.5,
    relatedBook: 'Starfall',
    isOfficialMerch: true,
    genre: 'Sci-Fi',
  },
  {
    id: '3',
    title: 'Beyond the Veil Bookmark Set',
    vendor: 'Page Markers',
    image:
      'https://images.unsplash.com/photo-1456735190827-d1262f71b8a3?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=600&q=80',
    price: 12.99,
    relatedBook: 'Beyond the Veil',
    genre: 'Fantasy',
  },
  {
    id: '4',
    title: 'Lost City Map Print',
    vendor: 'Adventure Art',
    image:
      'https://images.unsplash.com/photo-1513364776144-60967b0f800f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=600&q=80',
    price: 29.99,
    relatedBook: 'The Lost City',
    isOfficialMerch: true,
    genre: 'Adventure',
  },
]

// Trove Articles
export const troveArticles: TroveArticle[] = [
  {
    id: '1',
    title: 'The Rise of Dark Academia in Modern Fiction',
    author: 'Literary Scholar',
    image:
      'https://images.unsplash.com/photo-1507842217343-583bb7270b66?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    date: '2 days ago',
    category: 'Trends',
    excerpt:
      'Exploring the growing popularity of dark academia aesthetics in contemporary literature and its influence on indie publishing.',
  },
  {
    id: '2',
    title: 'Self-Publishing Success: Marketing Strategies That Work',
    author: 'Publishing Expert',
    image:
      'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    date: '1 week ago',
    category: 'Author Resources',
    excerpt:
      'Practical marketing strategies for indie authors looking to increase visibility and boost sales.',
  },
  {
    id: '3',
    title: 'How to Write Compelling Tropes Without Clichés',
    author: 'Writing Coach',
    image:
      'https://images.unsplash.com/photo-1455390582262-044cdead277a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    date: '2 weeks ago',
    category: 'Craft',
    excerpt:
      'Learn how to leverage popular tropes while keeping your story fresh and engaging for readers.',
  },
]

// Tropes & Vibes
export const tropesAndVibes: Trope[] = [
  {
    name: 'Enemies to Lovers',
    color: 'bg-pink-500',
    count: 247,
  },
  {
    name: 'Slow Burn',
    color: 'bg-red-500',
    count: 183,
  },
  {
    name: 'Found Family',
    color: 'bg-amber-500',
    count: 156,
  },
  {
    name: 'Forbidden Love',
    color: 'bg-purple-500',
    count: 142,
  },
  {
    name: 'Fake Dating',
    color: 'bg-pink-400',
    count: 134,
  },
  {
    name: 'Second Chance',
    color: 'bg-rose-500',
    count: 128,
  },
  {
    name: 'Grumpy/Sunshine',
    color: 'bg-yellow-500',
    count: 113,
  },
  {
    name: 'Forced Proximity',
    color: 'bg-orange-500',
    count: 109,
  },
  {
    name: 'Small Town',
    color: 'bg-blue-500',
    count: 98,
  },
  {
    name: 'Workplace Romance',
    color: 'bg-teal-500',
    count: 94,
  },
  {
    name: 'Marriage of Convenience',
    color: 'bg-violet-500',
    count: 87,
  },
  {
    name: 'Fish Out of Water',
    color: 'bg-cyan-500',
    count: 82,
  },
  {
    name: 'Only One Bed',
    color: 'bg-pink-600',
    count: 76,
  },
  {
    name: 'Why Choose',
    color: 'bg-indigo-600',
    count: 72,
  },
  {
    name: 'Fated Mates',
    color: 'bg-indigo-500',
    count: 68,
  },
  {
    name: 'Redemption Arc',
    color: 'bg-emerald-500',
    count: 64,
  },
  {
    name: 'Age Gap',
    color: 'bg-rose-600',
    count: 61,
  },
  {
    name: 'Accidental Pregnancy',
    color: 'bg-pink-500',
    count: 58,
  },
  {
    name: 'Hurt/Comfort',
    color: 'bg-blue-600',
    count: 54,
  },
  {
    name: 'Friends to Lovers',
    color: 'bg-green-500',
    count: 51,
  },
]

// Author Spotlight
export const spotlightAuthor: SpotlightAuthor = {
  id: '1',
  name: 'Elena Richards',
  bio: 'USA Today bestselling indie author of the Echo Series. Specializing in character-driven romantic suspense with unexpected twists.',
  image:
    'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  books: {
    debut: {
      id: '1',
      title: 'The Silent Echo',
      coverImage:
        'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      genres: ['Mystery', 'Thriller', 'Romance'],
      releaseDate: 'Jun 2018',
    },
    mostPopular: {
      id: '11',
      title: 'Midnight Shadows',
      coverImage:
        'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      genres: ['Mystery', 'Thriller'],
      rating: 4.9,
      reviewCount: 1283,
    },
    latest: {
      id: '12',
      title: 'Whispered Lies',
      coverImage:
        'https://images.unsplash.com/photo-1629992101753-56d196c8aabb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      genres: ['Mystery', 'Thriller'],
      releaseDate: 'Mar 2023',
      isNew: true,
    },
    leastReviewed: {
      id: '13',
      title: 'Hidden Truths',
      coverImage:
        'https://images.unsplash.com/photo-1621351183012-e2f9972dd9bf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      genres: ['Mystery', 'Thriller', 'Crime'],
      reviewCount: 42,
    },
  },
  socialLinks: {
    website: 'https://elenarichards.com',
    instagram: '@ElenaRichards',
    tiktok: '@ElenaRichardswrites',
  },
}

export const spotlightAuthors: SpotlightAuthor[] = [
  spotlightAuthor,
  {
    id: '2',
    name: 'Marcus Chen',
    bio: 'Award-winning author of the Mystical Realms series. Blending epic fantasy with heart-wrenching romance.',
    image:
      'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    books: {
      debut: {
        id: '21',
        title: 'Beyond the Veil',
        coverImage:
          'https://images.unsplash.com/photo-1518744386442-2d48ac55263f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
        genres: ['Fantasy', 'Romance'],
        releaseDate: 'Apr 2019',
      },
      mostPopular: {
        id: '22',
        title: 'Realm of Shadows',
        coverImage:
          'https://images.unsplash.com/photo-1589998059171-988d887df646?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
        genres: ['Fantasy', 'Romance'],
        rating: 4.8,
        reviewCount: 2150,
      },
      latest: {
        id: '23',
        title: 'The Final Enchantment',
        coverImage:
          'https://images.unsplash.com/photo-1603162525937-92a06da4b8ba?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
        genres: ['Fantasy', 'Romance'],
        releaseDate: 'Jan 2023',
        isNew: true,
      },
      leastReviewed: {
        id: '24',
        title: 'Whispers of Magic',
        coverImage:
          'https://images.unsplash.com/photo-1519074069444-1ba4fff66d16?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
        genres: ['Fantasy', 'Short Story'],
        reviewCount: 85,
      },
    },
    socialLinks: {
      website: 'https://marcuschen.com',
      instagram: '@MarcusChenWrites',
    },
  },
  {
    id: '3',
    name: 'Sophia Williams',
    bio: 'Master of the macabre and supernatural. Author of the Midnight Chronicles that will keep you up all night.',
    image:
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    books: {
      debut: {
        id: '31',
        title: 'Midnight Shadows',
        coverImage:
          'https://images.unsplash.com/photo-1621351183012-e2f9972dd9bf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
        genres: ['Horror', 'Supernatural'],
        releaseDate: 'Sep 2021',
      },
      mostPopular: {
        id: '32',
        title: 'Midnight Whispers',
        coverImage:
          'https://images.unsplash.com/photo-1633477189729-9290b3261d0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
        genres: ['Horror', 'Supernatural'],
        rating: 4.7,
        reviewCount: 1840,
      },
      latest: {
        id: '33',
        title: 'Midnight Secrets',
        coverImage:
          'https://images.unsplash.com/photo-1629992101753-56d196c8aabb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
        genres: ['Horror', 'Supernatural'],
        releaseDate: 'Apr 2024',
        isNew: true,
      },
      leastReviewed: {
        id: '34',
        title: 'The Dark House',
        coverImage:
          'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
        genres: ['Horror', 'Thriller'],
        reviewCount: 120,
      },
    },
    socialLinks: {
      website: 'https://sophiawilliams.com',
      instagram: '@SophiaWWrites',
    },
  },
]

// Theme of the Week
export const themeOfWeek: ThemeOfWeek = {
  theme: 'Why Choose Romance Week',
  description:
    "Explore stories where the heroine doesn't have to choose between love interests. These reverse harem and polyamorous romances celebrate multiple love connections.",
  color: 'bg-indigo-600',
  books: [
    {
      id: '20',
      title: 'Celestial Bonds',
      author: 'Jasmine Moon',
      coverImage:
        'https://images.unsplash.com/photo-1626788353765-b55f9fc8daf9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.8,
      genres: ['Paranormal Romance', 'Why Choose'],
      spiceLevel: 5,
      darknessLevel: 3,
      endingType: 'HEA',
      characterRelationships: [
        { type: 'Why Choose', style: ['Reverse Harem'] },
      ],
    },
    {
      id: '21',
      title: "The Queen's Guard",
      author: 'Victoria Knight',
      coverImage:
        'https://images.unsplash.com/photo-1633477189729-9290b3261d0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.6,
      genres: ['Fantasy Romance', 'Why Choose'],
      spiceLevel: 4,
      darknessLevel: 3,
      endingType: 'HEA',
      characterRelationships: [{ type: 'Why Choose', style: ['Fantasy'] }],
    },
    {
      id: '22',
      title: 'Academy of Shadows',
      author: 'Selene Black',
      coverImage:
        'https://images.unsplash.com/photo-1621351183012-e2f9972dd9bf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.7,
      genres: ['Urban Fantasy', 'Why Choose'],
      spiceLevel: 4,
      darknessLevel: 4,
      characterRelationships: [
        { type: 'Why Choose', style: ['Dark Academia'] },
      ],
    },
    {
      id: '23',
      title: 'Claimed by Three',
      author: 'Ruby Rose',
      coverImage:
        'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.9,
      genres: ['Contemporary Romance', 'Why Choose'],
      spiceLevel: 5,
      darknessLevel: 2,
      endingType: 'HEA',
      characterRelationships: [{ type: 'Why Choose', style: ['Contemporary'] }],
    },
  ],
}

// Reader Reviews
export const readerReviews: ReaderReview[] = [
  {
    id: '1',
    bookId: '1',
    bookTitle: 'The Silent Echo',
    bookCover:
      'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    author: 'Elena Richards',
    reviewerName: 'BookLover423',
    rating: 5,
    quote:
      "Absolutely couldn't put it down! The twist at the end had me gasping out loud.",
    date: '2 days ago',
  },
  {
    id: '2',
    bookId: '5',
    bookTitle: 'Starfall',
    bookCover:
      'https://images.unsplash.com/photo-1518744386442-2d48ac55263f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    author: 'Amara Knight',
    reviewerName: 'SciFiQueen',
    rating: 5,
    quote:
      'The world-building is phenomenal and the slow-burn romance had me swooning!',
    date: '3 days ago',
  },
  {
    id: '3',
    bookId: '8',
    bookTitle: 'The Last Spell',
    bookCover:
      'https://images.unsplash.com/photo-1589998059171-988d887df646?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    author: 'Finn Murphy',
    reviewerName: 'MagicReader',
    rating: 4,
    quote:
      "A fresh take on magic systems with compelling characters. Can't wait for the sequel!",
    date: '1 week ago',
  },
  {
    id: '4',
    bookId: '21',
    bookTitle: "The Queen's Guard",
    bookCover:
      'https://images.unsplash.com/photo-1633477189729-9290b3261d0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    author: 'Victoria Knight',
    reviewerName: 'FantasyFanatic',
    rating: 5,
    quote:
      'This why-choose romance is everything! All three love interests are perfectly developed.',
    date: '5 days ago',
  },
]

// Upcoming Events
export const upcomingEvents: UpcomingEvent[] = [
  {
    id: '1',
    title: 'Live Q&A with Elena Richards',
    date: 'May 15, 2023',
    time: '7:00 PM EST',
    type: 'Virtual',
    description:
      'Join bestselling author Elena Richards as she discusses her writing process and answers reader questions about the Echo Series.',
    image:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: '2',
    title: 'Book Signing: Marcus Chen',
    date: 'May 20, 2023',
    time: '2:00 PM PST',
    type: 'In-Person',
    location: 'Bright Corner Bookstore, Seattle',
    description:
      'Meet fantasy author Marcus Chen and get your copy of "Beyond the Veil" signed.',
    image:
      'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
  {
    id: '3',
    title: 'Indie Romance Panel',
    date: 'June 5, 2023',
    time: '6:30 PM EST',
    type: 'Virtual',
    description:
      'Join top indie romance authors as they discuss trends, tropes, and the future of indie publishing.',
    image:
      'https://images.unsplash.com/photo-1507842217343-583bb7270b66?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  },
]

export interface FeaturedBookBox {
  id: string
  name: string
  image?: string
  curatorImage?: string
  theme: string
  frequency: string
  price: string
  currency: string
  locationCountry: string
  shipping: string
  rating?: number
  reviewCount?: number
  description: string
}

export const featuredBookBoxes: FeaturedBookBox[] = [
  {
    id: 'bb1',
    name: 'Fantasy Realm Crate',
    image:
      'https://images.unsplash.com/photo-1512820790803-83ca734da794?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=600&q=80',
    theme: 'Fantasy, Magic, Adventure',
    frequency: 'Monthly',
    price: '39.99',
    currency: 'USD',
    locationCountry: 'United States',
    shipping: 'Worldwide',
    rating: 4.7,
    reviewCount: 234,
    description: 'Curated fantasy reads with exclusive bookish goodies.',
  },
  {
    id: 'bb2',
    name: 'Bookish & Spice',
    image:
      'https://images.unsplash.com/photo-1526243741027-444d633d7365?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=600&q=80',
    theme: 'Romance, Spicy, Contemporary',
    frequency: 'Monthly',
    price: '34.99',
    currency: 'USD',
    locationCountry: 'United States',
    shipping: 'US & Canada',
    rating: 4.8,
    reviewCount: 412,
    description: 'Steamy romance picks with themed merch and treats.',
  },
  {
    id: 'bb3',
    name: 'Mystery Maven Box',
    image:
      'https://images.unsplash.com/photo-1476275466078-4007374efbbe?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=600&q=80',
    theme: 'Mystery, Thriller, Suspense',
    frequency: 'Monthly',
    price: '36.99',
    currency: 'USD',
    locationCountry: 'United Kingdom',
    shipping: 'Worldwide',
    rating: 4.6,
    reviewCount: 189,
    description: 'Gripping mysteries with clue-themed collectibles.',
  },
]

// Platform Features for "What is LitLaunch" section
export const platformFeatures = [
  {
    id: 'trope-discovery',
    title: 'Trope-Based Discovery',
    description:
      'Find your next read based on the story elements you love, not just genres.',
    iconName: 'tag' as const,
  },
  {
    id: 'indie-focused',
    title: 'Indie Author Focused',
    description:
      'Connect directly with independent authors and support their creative journeys.',
    iconName: 'users' as const,
  },
  {
    id: 'all-in-one',
    title: 'All-in-One Platform',
    description:
      'Discover books, audiobooks, merchandise, and events all in one seamless experience.',
    iconName: 'sparkles' as const,
  },
]
